import type { AnyRoute } from '@tanstack/react-router';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

export const createHomeRoutes = <TParent extends AnyRoute>(parent: TParent) => {
  const homeRoute = createRoute({
    path: '/',
    getParentRoute: () => parent,
    component: lazyRouteComponent(() => import('./pages/HomePage'))
  });

  return [homeRoute];
};
